export default __webpack_public_path__ + "static/media/Qe_3.22e2983f.JPG";